/**
 * Quality grade chip showing A/B/C/unknown with color coding and tooltip.
 */
import React from 'react';
import { Chip, Tooltip } from '@mui/material';

const gradeColors = {
  A: 'success',   // green
  B: 'warning',   // yellow
  C: 'error',     // red
};

const QualityBadge = ({ qualityGrade, qualityScore, ephemerisSource, observationCount }) => {
  const grade = qualityGrade || 'unknown';
  const color = gradeColors[grade] || 'default'; // grey for unknown

  const tooltipLines = [];
  if (qualityScore != null) {
    tooltipLines.push(`Quality score: ${qualityScore.toFixed(2)}`);
  }
  if (ephemerisSource) {
    tooltipLines.push(`Ephemeris: ${ephemerisSource}`);
  }
  if (observationCount != null) {
    tooltipLines.push(`Observations: ${observationCount}`);
  }
  if (tooltipLines.length === 0) {
    tooltipLines.push('No quality data available');
  }

  return (
    <Tooltip title={tooltipLines.join(' | ')}>
      <Chip
        label={grade === 'unknown' ? '?' : grade}
        size="small"
        color={color}
        sx={{ minWidth: 28, height: 22, fontSize: '0.75rem', fontWeight: 'bold' }}
      />
    </Tooltip>
  );
};

export default QualityBadge;
